module.exports = __webpack_public_path__ + "static/img/collapse-arrow.6a8d0da.svg";